import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles((theme) => ({
  eventListingLogoWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    '& img': {
      top: pxToRem(-16),
      position: 'relative',
      objectFit: 'contain',
    },
  },
  headingTitle: {
    '& h1': {
      ...theme.palette.common.ellipsis(2),
    }
  },
  imageWrapper: {
    position: 'relative',
    height: '73px',
    width: '200px',
    [theme.breakpoints.up('xl')]: {
      width: '262px',
    },
    [theme.breakpoints.down('md')]: {
      paddingBottom: 0,
      display: 'none'
    },
  },
  favTitle: {
    paddingBottom: pxToRem(49),
    [theme.breakpoints.down('md')]: {
      paddingBottom: pxToRem(24),
    },
    '& .MuiTypography-root': {
      display: 'flex'
    },
  },
}));

export default useStyles;
